import { FC } from "react";

import { Table } from "@digital-services/ui";
import { SortQueryDirection } from "@ds-cps/ui";

import { Organization } from "@organization/models/Organization";

import { OrganizationDataRow } from "./OrganizationDataRow";
import { OrganizationsHeaderRow } from "./OrganizationsHeaderRow";

interface Props {
  organizations: Organization[];
  activeSort: string;
  sortDirection: SortQueryDirection | undefined;
  handleSort: (sortName: string) => void;
}

export const OrganizationsTable: FC<Props> = props => {
  const { organizations, activeSort, sortDirection, handleSort } = props;

  return (
    <Table className="w-full" rowHoverHighlight>
      <OrganizationsHeaderRow
        activeSort={activeSort}
        sortDirection={sortDirection}
        handleSort={handleSort}
      />
      <tbody data-testid="tbody">
        {organizations.map(org => (
          <OrganizationDataRow organization={org} key={`org-row-${org.id}`} />
        ))}
      </tbody>
    </Table>
  );
};
